import { render, staticRenderFns } from "./Proposta.vue?vue&type=template&id=082e795e"
import script from "./Proposta.vue?vue&type=script&lang=js"
export * from "./Proposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports